import React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CardActions, Stack } from "@mui/material";
import Divider from "@mui/material/Divider";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const Panel = (params) => {
  const {
    children,
    sx,
    title,
    collapsedDetail,
    elevation,
    expandable,
    startCollapsed,
    nopadding,
    actions,
    anchorName,
  } = params;
  const [expanded, setExpanded] = React.useState(!startCollapsed);
  const handleExpandClick = () => {
    if (!expandable) {
      return;
    }
    setExpanded(!expanded);
  };
  const paperSx = nopadding ? {} : { p: 3 };
  const titleSx = expandable ? { pb: expanded ? 2 : 0, cursor: "pointer" } : {};
  const titleSx2 = nopadding ? { mx: 3, pt: 3 } : {};
  const handleSx = nopadding ? { m: 3 } : { m: -1 };
  const actionsSx = nopadding ? {} : { mx: -3, mb: -3 };
  const isExpandableAndCollapsed = expandable && !expanded;
  return (
    <Paper
      sx={{ ...paperSx, ...(sx ?? {}) }}
      elevation={elevation ?? 3}
      id={anchorName}
      className="salt-Panel"
    >
      {expandable && (
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          sx={{ ...handleSx, float: "right" }}
        >
          <ExpandMoreIcon />
        </ExpandMore>
      )}
      {!!title && (
        <Typography
          gutterBottom
          variant="h6"
          component="div"
          sx={{ ...titleSx, ...titleSx2 }}
          onClick={handleExpandClick}
        >
          {title}
        </Typography>
      )}

      {!!collapsedDetail && !expanded && (
        <Typography
          gutterBottom
          variant="subtitle"
          component="div"
          sx={{ ...titleSx, ...titleSx2 }}
          onClick={handleExpandClick}
          color="text.secondary"
        >
          {collapsedDetail}
        </Typography>
      )}

      {expandable ? (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      ) : (
        children
      )}
      {actions && !isExpandableAndCollapsed && (
        <CardActions sx={{ ...actionsSx, justifyContent: "flex-end" }}>
          {actions}
        </CardActions>
      )}
    </Paper>
  );
};

export function PanelGroup({ children }) {
  return (
    <Paper
      variant="elevation"
      elevation={3}
      sx={{
        borderRadius: 1,
        overflow: "hidden",
        "& .salt-Panel": {
          borderRadius: 0,
          boxShadow: "none",
        },
      }}
    >
      <Stack divider={<Divider flexItem />}>{children}</Stack>
    </Paper>
  );
}
